const CONNECTION_ERROR = "Failed to connect. Please try again."

const extractError = (data) => data.error || data.errors?.join(", ") || "An error occurred"

const handleResponse = async (response) => {
  const data = await response.json()
  if (data.error || data.errors || !response.ok) {
    return { data, error: extractError(data), status: response.status }
  }
  return { data, error: null, status: response.status }
}

const request = async (fetchFn) => {
  try {
    const response = await fetchFn()
    return await handleResponse(response)
  } catch {
    return { data: null, error: CONNECTION_ERROR, status: null }
  }
}

export const postJson = (endpoint, body) =>
  request(() =>
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
  )

export const deleteJson = (endpoint) => request(() => fetch(endpoint, { method: "DELETE" }))

export const getJson = (endpoint) => request(() => fetch(endpoint))
